import styled, { css } from 'styled-components';
import { Typography } from '../../../../../global/theme';
import { mobile_xl } from '../../../../../global/mediaQueryMixin';

const InputSectionDiv = styled.div`
  /* min-width: -webkit-fill-available; */
  max-width: 400px;
  padding: 4px 7px 4px 4px;
  border: 0.5px solid var(--border-primary);
  border-radius: 6px;
  background-color: var(--background-primary);

  ${mobile_xl(css`
    min-width: calc(100vw - 90px);
  `)}
`;

const ProfileSection = styled.div`
  width: calc(100% - 25px);
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  overflow: hidden;
`;

const InputDiv = styled.div`
  flex-grow: 1;
  display: inline-flex;
  position: relative;
`;

const DummySpan = styled.span`
  max-width: 358px;
  flex-shrink: 1;
  box-sizing: border-box;
  text-overflow: ellipsis;
  white-space: nowrap;
  border: 0;
  overflow: hidden;
  ${Typography.body_lg}
  color: var(--text-primary);
  padding: 3px 0 3px 3px;
`;

const Input = styled.input`
  max-width: 358px;
  width: 100%;
  height: 100%;
  max-height: 26px;
  padding: 0;
  position: absolute;
  top: 0;
  left: 3px;
  border: none;
  outline: none;
  ${Typography.body_lg}
  color: var(--text-primary);
  background: var(--background-primary);

  ::placeholder {
    color: var(--text-placeholder);
  }
  :focus-visible {
    border-color: var(--brand-primary);
    outline: unset;
  }
`;

const ProfileTag = styled.div`
  border-radius: 6px;
  border: 0.5px solid var(--border-primary);
  padding: 2px 3px;
  display: flex;
  align-items: center;
  gap: 6px;
  ${Typography.body_md_medium}
  color: var(--text-primary);
`;

const Icon = styled.div`
  padding: 3px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  cursor: pointer;
  :hover {
    background-color: var(--neutral-secondary);
  }
`;

export { InputSectionDiv, Input, ProfileSection, ProfileTag, Icon, InputDiv, DummySpan };
